import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`};
`

export const StyledBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ noResults, isMultidestiny }) => noResults && !isMultidestiny && 'flex-end'};
  align-items: ${({ isMultidestiny }) => (isMultidestiny ? 'flex-end' : 'center')};
  width: 50%;
  ${mediaQueries.tablet`
      width: ${({ isConference }) => (isConference ? '100%' : '400px')};
  `};
  ${mediaQueries.mobile`
    width: 0;
  `};
`
export const FragmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`};
  ${({ width }) => width && `width: ${width};`};
`

export const Container = styled.div.attrs(() => ({
  className: 'search-box'
}))`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => props.isResearch && !props.isResearchBoxExpanded && `height: 0;`};
  ${mediaQueries.tablet`
      width: ${({ isConference }) => (isConference ? '100%' : '400px')};
  `};
  ${mediaQueries.mobile`
    width: 100%;
  `};
`

export const CampaignInputLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.doveGray};
  font-weight: 600;
  margin-right: 20px;
  white-space: nowrap;
  letter-spacing: 1px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
`

export const Label = styled.label.attrs(props => ({
  className: `${e2eClasses('common.inputTitle') || ''}${props.e2eClass || ''}`,
  htmlFor: props.forId
}))`
  display: flex;
  color: ${({ theme }) => theme.colors.doveGray};
  padding: 14px 0;
  font-size: 14px;
  font-family: ${({ isResearch, theme }) =>
    isResearch ? theme.fonts.semiBold : theme.fonts.regular};

  ${({ boldBlue, theme }) =>
    boldBlue &&
    `
    font-family: ${theme.fonts.semiBold};
    color: ${theme.colors.blue50};
    font-size: 16px;
    padding: 0 0 0 8px;
  `}

  ${mediaQueries.tablet/*Hides visually but not for screen-readers*/ `
    clip: rect(0 0 0 0); 
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap; 
    width: 1px;
    ${({ boldBlue, theme }) =>
      boldBlue &&
      `
      display: flex;
      font-family: ${theme.fonts.semiBold};
      color: ${theme.colors.blue50};
      font-size: 18px;
    `}
  `};
`

export const Separator = styled.div`
  width: 30px;
`

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  font-size: 18px;
  padding-bottom: 15px;
  ${mediaQueries.mobile`
    padding-bottom: 0;
  `};
`

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const FieldsContainer = styled.div`
  display: flex;
  width: 100%;

  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}

  ${mediaQueries.tablet`
    flex-direction: column;
    ${({ flexDatesAllowed }) => !flexDatesAllowed && 'margin-bottom: 20px;'}
  `};
`
export const CampaignConditionalFieldsItem = styled.div`
  display: flex;
  align-items: center;
  min-width: 30%;
  margin: 10px;
  ${mediaQueries.mobile`
    margin: ${props => (props.isLast ? '0 0 30px 0' : '0 0 5px 0')};
  `}
`
CampaignConditionalFieldsItem.propTypes = {
  isLast: PropTypes.bool
}

export const CampaignConditionalFields = styled(FieldsContainer)`
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  ${mediaQueries.mobile`
    margin-bottom: 0;
  `}
`

export const Leg = styled.div.attrs(props => ({
  className: `leg-${props.legIndex + 1}`
}))`
  display: flex;
  ${({ flexDirection }) => flexDirection && `flex-direction: ${flexDirection};`}
  ${mediaQueries.tablet`
    flex-direction: column;
  `};

  ${props =>
    props.showMultidestiny &&
    `
      padding: 10px 0 30px;
      ${props => props.legIndex === 0 && `padding: 0 0 30px;`};
    `};
`

export const LegTitleWrapper = styled.label`
  display: flex;
  align-items: center;
  padding: 46px 64px 0 0;
  width: ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? '300px'
      : '128px'};
  ${mediaQueries.tablet`
    width: 100%;
    justify-content: space-between;
    padding: 0;
  `};
`

export const LegTitleIcon = styled.div`
  display: none;

  svg {
    path {
      fill: ${({ theme }) => theme.colors.blue};
    }
  }

  ${mediaQueries.tablet`
    display: block;
  `};
`

export const LegLabel = styled.label`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blue50};
  letter-spacing: 0.5px;
  padding: 2px 0 2px 7px;
  border-left: solid 5px ${({ theme }) => theme.colors.blue};
  ${mediaQueries.tablet`
    font-size: 18px;
  `};
`

const InputWrapperTabletCSS = css`
  width: 100%;
  flex-direction: column;
  height: auto;
  display: ${({ isExpanded }) => (isExpanded ? 'flex' : 'none')};
`
export const InputWrapper = styled.div`
  display: flex;
  ${({ isConference }) => isConference && InputWrapperTabletCSS}
  ${mediaQueries.tablet`
    ${InputWrapperTabletCSS}
  `};
`

export const EditLegWrapper = styled.div.attrs(props => ({
  className: `${props.name}${props.index + 1 ? `-${props.index + 1}` : ''}`
}))`
  display: flex;
  align-items: center;

  ${({ name }) =>
    name === 'delete-leg'
      ? `
    margin-left: 13px;
    padding-top: 46px;
  `
      : ` padding: 0 0 30px 130px;`};

  ${({ isResearch }) => isResearch && 'padding: 15px 0 0'};

  ${mediaQueries.tablet`
    ${({ name }) =>
      name === 'delete-leg'
        ? `
      margin: 30px 10px 0 0;
      padding: 0;`
        : 'padding: 0 0 20px;'};
  `};
`

export const EditLegLabel = styled.label`
  display: flex;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: 0.66px;
  ${mediaQueries.mobile`
    font-size: 16px;
  `};
`

export const SeparatorWrapper = styled.div`
  width: ${({ last }) => (last ? '100%' : '70%')};
  ${mediaQueries.tablet`
   width: 100%;
  `};
`

export const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isConference, isRoundTrip }) =>
    isConference ? '100%' : isRoundTrip ? '300px' : '135px'};

  ${mediaQueries.tablet`
    width: 100%;
    margin: 30px 0 0 0;
  `};
`

export const SwitcherContainer = styled.div`
  width: 220px;
  padding: 20px 0 25px;

  ${mediaQueries.tablet`
    width: 100%;
  `};
`

export const IconLabelWrapper = styled.div`
  display: flex;
  width: 128px;

  ${props => props.hide && `display: none;`};
  ${mediaQueries.tablet`
    width: 100%;
    padding: 20px 0;
  `};
`

export const ConferenceConfigPassengerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;

  ${mediaQueries.mobile`
    justify-content: center;
  `};
`

export const ConferenceCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 46%;
  ${mediaQueries.mobile`
    width: 100%;
    margin-bottom: 20px;
  `}
`

export const ConfigPassengerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ isConference, theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? ''
      : isConference
      ? '46%'
      : '205px'};
  ${({ paddingBottom }) => paddingBottom && `padding-bottom: ${paddingBottom};`};
  ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft}`};
  ${({ paddingTop }) => paddingTop && `padding-top: ${paddingTop}`};
  ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true' &&
    `margin-left: 150px;`}

  ${({ orientationRow }) =>
    orientationRow &&
    `
  flex-direction: row;
  padding-top: 30px;
  width: 100%;
  `};

  ${({ isConference }) =>
    isConference
      ? mediaQueries.mobile`
    width: 100%;
  `
      : mediaQueries.tablet`
      width: 100%;
  `}
`

export const AirportContainer = styled.div`
  width: ${({ isConference, theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? '340px'
      : isConference
      ? '100%'
      : '200px'};
  ${mediaQueries.tablet`
    width: 100%;
    margin: 30px 0 0 0;
    position: relative;
  `};
`

export const SwapFieldsWrapper = styled.div`
  padding-top: 50px;
  ${mediaQueries.tablet`
    display: none;
  `};
`

export const ButtonContainer = styled.div`
  ${({ flex }) => (flex && `flex: ${flex};`) || `width: 400px;`}

  ${props =>
    props.isResearch &&
    css`
      padding-top: 45px;
      width: 167px;
    `};

  ${mediaQueries.tablet`
    width: 100%;
  `};
  ${mediaQueries.mobile`
    margin-top: 0;
    flex: none;
  `};
`
export const ConferenceButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${mediaQueries.mobile`
    justify-content: center;
  `};
`

export const ConferenceConditions = styled.a.attrs(() => ({
  className: e2eClasses('searchBox.conditionsButton')
}))`
  display: flex;
  font-size: 14px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  ${mediaQueries.mobile`
    order: 1;
    margin: 5px 0;
  `};
`

export const ModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100vh;
  width: 100vw;
  z-index: 10;
  overflow: auto;
`

export const ModalHeader = styled.div`
  display: flex;
  padding: 35px 15px 15px 15px;
`

export const ImageLogoContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

export const ImageLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;

  img {
    width: 100%;
  }
`

export const ButtonCloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 35px;
  right: 20px;
  z-index: 20;
`

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`

export const TitleIconContainer = styled.div`
  padding: 20px 15px 10px 15px;
`

export const TitleText = styled.div`
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.blue};
`

export const ModalDatePickerContainer = styled.div``

export const DatePickersContainer = styled.div`
  position: relative;
`

export const OpenDateResponsivePickerOnly = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -10;

  ${mediaQueries.mobile`
    z-index: 10;
  `};
`

export const PromoCodeContainer = styled.div`
  width: 220px;
  padding: 20px 0 25px;

  ${mediaQueries.tablet`
    width: 100%;
  `};
`

export const SwitchersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`
